export default "__VITE_ASSET__D5cvFM75__"